<template>
  <div class="total">
    <div class="inner">
      <h2>时间格式转换</h2>
      <h6>现在时间为：{{nowTime}}</h6>
      <h4>请输入时间戳(毫秒)</h4>
      <el-container>
        <el-input v-model="timestamp" @keyup.native="changeTimestamp" @change="changeTimestamp" style="width: 80%" placeholder="请输入时间戳（毫秒）" type="number" step="1000"></el-input>
        <el-input v-model="timestampFormat" @keyup.native="changeTimestampFormat" style="width: 20%" placeholer="请输入时间格式"></el-input>
      </el-container>

      <h4>结果</h4>
      <el-input :value="timestampResult"></el-input>

      <h4>请输入格式化时间</h4>
      <el-container>
        <el-input v-model="dateString" @keyup.native="changeDate" style="width: 80%" placeholder="请输入格式化时间" type="text"></el-input>
        <el-input v-model="dateFormat" @keyup.native="changeDateFormat" style="width: 20%" placeholer="请输入时间格式"></el-input>
      </el-container>

      <h4>结果(毫秒)</h4>
      <el-input :value="dateResult"></el-input>

      <el-row style="margin-top: 50px;text-align: center">
        <el-col :span="3">
          <el-input v-model="inputYear" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入年" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">年</el-col>
        <el-col :span="3">
          <el-input v-model="inputMonth" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入月" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">月</el-col>
        <el-col :span="3">
          <el-input v-model="inputDay" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入日" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">日</el-col>
        <el-col :span="3">
          <el-input v-model="inputHour" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入小时" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">时</el-col>
        <el-col :span="3">
          <el-input v-model="inputMinute" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入分钟" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">分</el-col>
        <el-col :span="3">
          <el-input v-model="inputSecond" @keyup.native="changeInput" @change.native="changeInput" placeholder="请输入秒" type="number"></el-input>
        </el-col>
        <el-col :span="1" class="time-label">秒</el-col>
      </el-row>

      <h4>结果(毫秒)</h4>
      <el-input :value="inputResult"></el-input>
    </div>

  </div>
</template>

<script>
    export default {
        name: "TimeConverter",
        data() {
            return {
                timestamp: 0,
                timestampResult: '',
                nowTime: '',
                timestampFormat: 'YYYY-MM-DD HH:mm:ss',
                dateString: '',
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                dateResult: 0,
                inputYear: 0,
                inputMonth: 0,
                inputDay: 0,
                inputHour: 0,
                inputMinute: 0,
                inputSecond: 0,
                inputResult: 0,
            }
        },
        methods: {
            changeTimestamp() {
                console.log('changeTimestamp')
                // this.timestampResult=this.$moment(this.timestamp).format('YYYY-MM-DD HH:mm:ss')
                this.timestampResult = this.$moment.unix(this.timestamp / 1000).format(this.timestampFormat)
            },
            changeTimestampFormat() {
                this.timestampResult = this.$moment.unix(this.timestamp / 1000).format(this.timestampFormat)
            },
            changeDate() {
                this.dateResult = this.$moment(this.dateString, this.dateFormat).valueOf()
            },
            changeDateFormat() {
                this.dateResult = this.$moment(this.dateString, this.dateFormat).valueOf()
            },
            changeInput() {
                let timeString = this.inputYear + "-" + this.inputMonth + "-" + this.inputDay + " " + this.inputHour + ":" + this.inputMinute + ":" + this.inputSecond
                console.log('输入的时间为：' + timeString)
                this.inputResult = this.$moment(timeString, 'YYYY-MM-DD HH:mm:ss').valueOf()
            }
        },
        mounted() {
            this.timestamp = new Date().getTime()
            this.timestampResult = this.$moment.unix(this.timestamp / 1000).format(this.timestampFormat)
            this.dateString = this.timestampResult
            this.dateResult = this.dateResult = this.$moment(this.dateString, this.dateFormat).valueOf()
            setInterval(() => {
                let nowTimeStamp = new Date().getTime()
                this.nowTime = nowTimeStamp + "\t" + this.$moment.unix(nowTimeStamp / 1000).format(this.timestampFormat)
            }, 21)
            this.inputYear = this.$moment().year()
            this.inputMonth = this.$moment().month() + 1
            this.inputDay = this.$moment().day()
            this.inputHour = this.$moment().hour()
            this.inputMinute = this.$moment().minute()
            this.inputSecond = this.$moment().second()
            this.changeInput()
        }
    }
</script>

<style scoped>
  div.total {
    width: 100%;
    height: 100%;
    text-align: center;
  }

  div.inner {
    width: 60%;
    margin: 0 auto;
  }

  .time-label {
    margin-top: 10px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: textfield;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }


</style>



// WEBPACK FOOTER //
// src/components/TimeConverter.vue